import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { fmtDate as fmtDatePt } from '@/utils/dateFmt';

/**
 * PROMPT 4 — extraído de AdminDesafiosPage para corrigir bug do <Dialog> duplicado.
 * Comportamento idêntico: renderiza notas da paciente + permite à nutri adicionar/editar a nota
 * dela mesmo quando não há registo da paciente no próprio dia.
 */
export default function ParticipantNotesDialog({
  open,
  onClose,
  participantName,
  notesList,
  editingNoteDate,
  setEditingNoteDate,
  editingNoteValue,
  setEditingNoteValue,
  onSaveNutriNote,
}) {
  const today = new Date().toISOString().slice(0, 10);
  return (
    <Dialog open={open} onOpenChange={(o) => { if (!o) onClose(); }}>
      <DialogContent className="rounded-3xl border-brand-border max-w-lg" data-testid="participant-notes-dialog">
        <DialogHeader><DialogTitle className="font-heading text-brand-text">Notas — {participantName}</DialogTitle></DialogHeader>
        {notesList.length === 0 ? (
          <p className="text-xs text-brand-muted py-4 text-center">Sem notas registadas neste desafio.</p>
        ) : (
          <div className="space-y-2 max-h-96 overflow-y-auto">
            {notesList.map(d => (
              <div key={d.date} className="bg-brand-bg/40 border border-brand-border rounded-xl p-3" data-testid={`note-day-${d.date}`}>
                <div className="flex items-center justify-between mb-1">
                  <span className="text-[10px] text-brand-muted">{fmtDatePt(d.date)}</span>
                  {d.feeling && <span className="text-[9px] bg-brand-mint/20 text-brand-green px-1.5 py-0.5 rounded-full">{d.feeling}</span>}
                </div>
                {d.note && <p className="text-xs text-brand-text italic" data-testid={`note-patient-${d.date}`}>&quot;{d.note}&quot;</p>}
                {editingNoteDate === d.date ? (
                  <div className="mt-2">
                    <textarea value={editingNoteValue} onChange={e => setEditingNoteValue(e.target.value)} rows={2} className="w-full text-xs bg-white border border-brand-border rounded-xl px-2 py-1.5 resize-none" data-testid={`note-nutri-input-${d.date}`} />
                    <div className="flex gap-1.5 mt-1.5">
                      <button onClick={() => onSaveNutriNote(d.date, editingNoteValue)} className="text-[10px] bg-brand-green text-white rounded-full px-3 py-1" data-testid={`note-nutri-save-${d.date}`}>Guardar</button>
                      <button onClick={() => { setEditingNoteDate(''); setEditingNoteValue(''); }} className="text-[10px] text-brand-muted px-2">Cancelar</button>
                    </div>
                  </div>
                ) : d.nutri_note ? (
                  <div className="mt-1.5 bg-brand-green/8 border-l-2 border-brand-green rounded px-2 py-1 cursor-pointer" onClick={() => { setEditingNoteDate(d.date); setEditingNoteValue(d.nutri_note); }} data-testid={`note-nutri-${d.date}`}>
                    <span className="text-[9px] text-brand-green font-semibold uppercase tracking-wide">Resposta à paciente (ela vê esta mensagem no ecrã Metas)</span>
                    <p className="text-[11px] text-brand-green">{d.nutri_note}</p>
                  </div>
                ) : (
                  <button onClick={() => { setEditingNoteDate(d.date); setEditingNoteValue(''); }} className="mt-1.5 text-[10px] text-brand-green underline" data-testid={`note-nutri-add-${d.date}`}>+ Adicionar nota da nutri</button>
                )}
              </div>
            ))}
            {!notesList.find(n => n.date === today) && (
              <div className="bg-white border border-dashed border-brand-border rounded-xl p-3">
                <p className="text-[10px] text-brand-muted mb-1">Hoje ({today}) — sem registo da paciente.</p>
                <button onClick={() => { setEditingNoteDate(today); setEditingNoteValue(''); }} className="text-[10px] text-brand-green underline" data-testid="note-nutri-add-today">+ Nota só da nutri para hoje</button>
                {editingNoteDate === today && (
                  <div className="mt-2">
                    <textarea value={editingNoteValue} onChange={e => setEditingNoteValue(e.target.value)} rows={2} className="w-full text-xs bg-brand-bg border border-brand-border rounded-xl px-2 py-1.5 resize-none" data-testid="note-nutri-input-today" />
                    <button onClick={() => onSaveNutriNote(today, editingNoteValue)} className="mt-1.5 text-[10px] bg-brand-green text-white rounded-full px-3 py-1" data-testid="note-nutri-save-today">Guardar</button>
                  </div>
                )}
              </div>
            )}
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
